import { GlobalErrorFallback } from "@app/ui/GlobalErrorFallback";
import { createRouter } from "@tanstack/react-router";
import { queryClient } from "./queryClient";
import { routeTree } from "./routeTree.gen";

const PROJECT_PAGE_PATH = /^\/projects\/\d+\/?$/;

/**
 * 프로젝트 Documents 목록의 스크롤 위치는 공사일지 검색 복원 모듈이 소유한다
 * (features/project-detail/model/use-daily-log-search-scroll-restoration).
 * Router 자동 복원까지 적용되면 예전에 기록된 값으로 목록 위치를 덮어쓰므로 이 화면만 제외한다.
 */
function isDailyLogSearchListLocation(location: { pathname: string; search: Record<string, unknown> }) {
  return PROJECT_PAGE_PATH.test(location.pathname) && location.search.tab === "documents";
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultErrorComponent: ({ reset }) => <GlobalErrorFallback resetError={reset} />,
  defaultPreload: "intent",
  scrollRestoration: ({ location }) => !isDailyLogSearchListLocation(location),
  defaultPreloadStaleTime: 1000 * 60 * 5,
  defaultViewTransition: {
    types: ({ fromLocation, toLocation }) => {
      if (!fromLocation) return ["forward"];

      const fromIndex = fromLocation.state.__TSR_index ?? 0;
      const toIndex = toLocation.state.__TSR_index ?? 0;

      return [fromIndex > toIndex ? "back" : "forward"];
    },
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
